import React from "react";
import { formatBookingDate } from "./formatBookingDate";

const ScheduledDayGroup = ({ dateKey, children, leading }) => (
  <section className="se-day-group">
    <h2 className="se-day">
      {leading || null}
      <strong className="se-day__date">
        {formatBookingDate(dateKey, "DD-MM-YYYY")}
      </strong>
    </h2>
    <div className="rd_eventcardscontainer se-day-group__list">{children}</div>
  </section>
);

export default ScheduledDayGroup;
